var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCompare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 26,
    viewBox: "0 0 41 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M4.386 2.674H.404V.642h3.982z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M2.643.42v4.023H.074V.421z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M0 12.924V0h24.903v25.848H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.957 23.174)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.122 2.635a13.085 13.085 0 0 1-1.718-.25L.776.642C1.9.882 3.076.95 4.214.84l.172 1.773c-.748.072-1.509.08-2.264.02",
    fill: "currentColor",
    fillRule: "nonzero",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.785 23.592a12.985 12.985 0 0 1-2.905-2.736l1.405-1.095a11.19 11.19 0 0 0 2.506 2.36l-1.007 1.47h.001zm13.328.765l-.833-1.577a11.181 11.181 0 0 0 2.76-2.057l1.272 1.248a12.963 12.963 0 0 1-3.2 2.386z",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.326 13.37)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.725 4.443L.074 3.77C.508 2.705.775 1.577.864.421l1.254.062.525.062a12.952 12.952 0 0 1-.92 3.898",
    fill: "currentColor",
    fillRule: "nonzero",
    mask: "url(#d)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.636 9.042l-1.671-.62A12.881 12.881 0 0 1 17.92 4.94l1.4 1.102a11.075 11.075 0 0 0-1.684 3zm21.048.442a11.157 11.157 0 0 0-1.557-3.068l1.447-1.042a12.915 12.915 0 0 1 1.806 3.56l-1.696.55zm-15.43-6.602l-.774-1.607A12.819 12.819 0 0 1 26.303.121l.243 1.765a11.077 11.077 0 0 0-3.293.996h.001zm10.741.596a11.014 11.014 0 0 0-3.162-1.354L31.27.397c1.303.33 2.538.858 3.673 1.571l-.949 1.51zM23.358 20.552l-1.438-1.054c.485-.662.895-1.377 1.223-2.13l1.634.713a12.96 12.96 0 0 1-1.42 2.47z",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 12.924C0 5.798 5.798 0 12.924 0a12.906 12.906 0 0 1 11.908 7.893s-1.643.694-1.642.695a11.127 11.127 0 0 0-10.266-6.805c-6.144 0-11.141 4.997-11.141 11.14 0 6.145 4.997 11.142 11.14 11.142 1.658 0 3.252-.355 4.74-1.054 0 0 .75 1.612.758 1.612a12.808 12.808 0 0 1-5.497 1.225C5.798 25.848 0 20.05 0 12.924z",
    fill: "currentColor",
    fillRule: "nonzero",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.924 15.152a2.23 2.23 0 0 1-2.228-2.228c0-1.228 1-2.228 2.228-2.228 1.228 0 2.228 1 2.228 2.228 0 1.228-1 2.228-2.228 2.228zm0-6.239a4.015 4.015 0 0 0-4.011 4.01c0 2.211 1.8 4.012 4.01 4.012 2.212 0 4.012-1.8 4.012-4.011 0-2.211-1.8-4.011-4.011-4.011zm15.15 8.022c-.801 0-1.584-.24-2.247-.69a3.969 3.969 0 0 1-1.177-1.235l1.523-.926c.166.273.386.504.654.685.989.67 2.431.384 3.095-.596l1.476.998a4.01 4.01 0 0 1-3.325 1.765v-.001zm1.906-5.17a2.208 2.208 0 0 0-.655-.686c-.989-.67-2.429-.385-3.093.594l-1.476-.999a4.01 4.01 0 0 1 6.748.166l-1.524.925z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCompare);
export default __webpack_public_path__ + "static/media/icon-compare.f8d4d39f.svg";
export { ForwardRef as ReactComponent };